import {
	ADD_QUARANTENA_HISTORY_FAIL,
	ADD_QUARANTENA_HISTORY_START,
	ADD_QUARANTENA_HISTORY_SUCCESS,
	ADD_STORICO_PRENOTAZIONE_FAIL,
	ADD_STORICO_PRENOTAZIONE_START,
	ADD_STORICO_PRENOTAZIONE_SUCCESS,
	ASK_FOR_MONITORAGGIO_FAIL,
	ASK_FOR_MONITORAGGIO_START,
	ASK_FOR_MONITORAGGIO_SUCCESS,
	GENERATE_MONITORAGGIO_FAIL,
	GENERATE_MONITORAGGIO_START,
	GENERATE_MONITORAGGIO_SUCCESS,
	GENERATE_QUARANTENA_FAIL,
	GENERATE_QUARANTENA_START,
	GENERATE_QUARANTENA_SUCCESS,
	GET_ALL_INFO_PROTOCOLLI_FAIL,
	GET_ALL_INFO_PROTOCOLLI_START,
	GET_ALL_INFO_PROTOCOLLI_SUCCESS,
	GET_ALL_INFO_QUARANTENE_FAIL,
	GET_ALL_INFO_QUARANTENE_START,
	GET_ALL_INFO_QUARANTENE_SUCCESS,
	GET_ALL_MONITORAGGI_FAIL,
	GET_ALL_MONITORAGGI_START,
	GET_ALL_MONITORAGGI_SUCCESS,
	GET_FOCOLAIO_FAIL,
	GET_FOCOLAIO_START,
	GET_FOCOLAIO_SUCCESS,
	GET_PROTOCOLLO_FAIL,
	GET_PROTOCOLLO_START,
	GET_PROTOCOLLO_SUCCESS,
	GET_QUARANTENA_FAIL,
	GET_QUARANTENA_HISTORY_FAIL,
	GET_QUARANTENA_HISTORY_START,
	GET_QUARANTENA_HISTORY_SUCCESS,
	GET_QUARANTENA_START,
	GET_QUARANTENA_SUCCESS,
	GET_QUARANTENE_BY_DAY_FAIL,
	GET_QUARANTENE_BY_DAY_START,
	GET_QUARANTENE_BY_DAY_SUCCESS,
	GET_QUARANTENE_BY_MONTH_FAIL,
	GET_QUARANTENE_BY_MONTH_START,
	GET_QUARANTENE_BY_MONTH_SUCCESS,
	MODIFY_ALIAS_FOCOLAIO_FAIL,
	MODIFY_ALIAS_FOCOLAIO_START,
	MODIFY_ALIAS_FOCOLAIO_SUCCESS,
	PROTOCOLLA_PROTOCOLLO_FAIL,
	PROTOCOLLA_PROTOCOLLO_START,
	PROTOCOLLA_PROTOCOLLO_SUCCESS,
	RESET_GET_QUARANTENE_DAY,
	UPDATE_FOCOLAIO_FAIL,
	UPDATE_FOCOLAIO_START,
	UPDATE_FOCOLAIO_SUCCESS,
	UPDATE_PROTOCOLLO_FAIL,
	UPDATE_PROTOCOLLO_START,
	UPDATE_PROTOCOLLO_SUCCESS,
	UPDATE_QUARANTENA_FAIL,
	UPDATE_QUARANTENA_START,
	UPDATE_QUARANTENA_SUCCESS
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {
	ADD_QUARANTENA_HISTORY_URL, ADD_STORICO_PRENOTAZIONE_URL,
	ASK_FOR_MONITORAGGIO_URL,
	DOWNLOAD_PROTOCOLLO_URL,
	GENERATE_FOCOLAIO_URL,
	GENERATE_MONITORAGGIO_URL, GENERATE_PDF_URL,
	GENERATE_PROTOCOLLO_URL,
	GENERATE_QUARANTENA_URL,
	GENERATE_QUARANTENA_V2_URL, GENERATE_QUARANTENA_V3_URL, GENERATE_QUARANTENA_V4_URL, GENERATE_QUARANTENA_V5_URL,
	GET_ALL_FOCOLAI_URL,
	GET_ALL_INFO_PROTOCOLLI_URL,
	GET_ALL_INFO_QUARANTENE_URL,
	GET_ALL_MONITORAGGI_QUARANTENA_URL,
	GET_ALL_MONITORAGGI_SOGGETTO_URL,
	GET_ALL_PROTOCOLLI_URL,
	GET_ALL_QUARANTENE_URL,
	GET_QUARANTENA_HISTORY_URL,
	GET_QUARANTENA_URL,
	GET_QUARANTENE_BY_MONTH_URL, MODIFY_ALIAS_FOCOLAIO_URL,
	PROTOCOLLA_PROTOCOLLO_URL,
	UPDATE_FOCOLAIO_URL,
	UPDATE_PROTOCOLLO_URL,
	UPDATE_QUARANTENA_URL
} from "./utils/ApiUrls";
import {getConfig} from "./utils/ConfigUtils";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {getProtocolloData} from "./utils/ApiData";
import {endOfMonth, startOfMonth} from "date-fns";
import moment from "moment";
import {etichetteQuarantena} from "../utils/arrays/Generics";

export function generateQuarantenaV2(quarantena, dispatch) {
	dispatch({type: GENERATE_QUARANTENA_START});
	axios
		.post(GENERATE_QUARANTENA_V2_URL, quarantena, getConfig())
		.then((response) => {
			dispatch({
				type: GENERATE_QUARANTENA_SUCCESS,
				data: response.data?.["idQuarantena"],
				payload: response.data?.["idFocolaio"],
			})
		})
		.catch((error) => dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)}))
}

function getEtichetta(data) {
	let etichetta = null;
	if (data.ricoverato && data.ricoverato === "true") {
		etichetta = etichetteQuarantena[1];
	}
	if (data.appartieneComunita && data.appartieneComunita === "true") {
		etichetta = etichetteQuarantena[6];
	}
	if (data.seguitoDaMedico && data.seguitoDaMedico === "true") {
		etichetta = etichetteQuarantena[2];
	}
	if (data.immunodepresso && data.immunodepresso === "true") {
		etichetta = etichetteQuarantena[0];
	}
	return etichetta;
}

export function generateQuarantenaV3(idSoggetto, data, idIntervista, score, tipoPaziente, idTampone, dispatch, idFocolaio) {
	dispatch({type: GENERATE_QUARANTENA_START});
	axios
		.post(GENERATE_QUARANTENA_V3_URL, {
			...data,
			tipo: tipoPaziente === "PAZ_ZERO" ? "Isolamento" : "Quarantena",
			note: data["noteQuarantena"],
			idIntervista: idIntervista,
			idTampone: idTampone,
			idFocolaio: idFocolaio,
			aliasFocolaio: data.comunita ? data.comunita : null,
			tag: getEtichetta(data),
			score: score,
			deleted: false,
			groupId: data.tipoContatto ? data.tipoContatto : "Contatto convivente",
			soggetto: {
				idSoggetto: idSoggetto,
			},
			tipoPaziente: tipoPaziente,
			contatti: data["contatti"] ? data["contatti"] : []
		})
		.then((response) => {
			dispatch({
				type: GENERATE_QUARANTENA_SUCCESS,
				data: response.data?.["idQuarantena"],
				payload: response.data?.["idFocolaio"],
			})
		})
		.catch((error) => dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)}))
}

export function generateQuarantenaV4(soggetto, data, idIntervista, idFocolaio, dispatch) {
	dispatch({type: GENERATE_QUARANTENA_START});
	axios
		.post(GENERATE_QUARANTENA_V4_URL, {
			...data,
			idIntervista: idIntervista,
			idFocolaio: idFocolaio,
			tag: getEtichetta(data),
			deleted: false,
			soggetto: soggetto,
			contatti: [],
		}, getConfig())
		.then((response) => {
			dispatch({
				type: GENERATE_QUARANTENA_SUCCESS,
				data: response.data?.["idQuarantena"],
				payload: response.data?.["idFocolaio"],
			})
		})
		.catch((error) => dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)}))
}

export function generateQuarantenaV5(soggetto, data, dispatch) {
	dispatch({type: GENERATE_QUARANTENA_START});
	axios
		.post(GENERATE_QUARANTENA_V5_URL, {
			...data,
			deleted: false,
			soggetto: soggetto,
			contatti: [],
		}, getConfig())
		.then((response) => {
			dispatch({
				type: GENERATE_QUARANTENA_SUCCESS,
				data: response.data?.["idQuarantena"],
				payload: response.data?.["idFocolaio"],
			})
		})
		.catch((error) => dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)}))
}

export function generateQuarantena(quarantena, dispatch, generateFocolaio = false, idFocolaio, tipoPaziente) {
	dispatch({type: GENERATE_QUARANTENA_START})
	axios
		.post(GENERATE_QUARANTENA_URL, quarantena, getConfig())
		.then((response) => {
			if (generateFocolaio) {
				axios
					.post(GENERATE_FOCOLAIO_URL, {
						tipo: "test",
						associazioni: [
							response.data,
						]
					}, getConfig())
					.then((response2) => {
						axios
							.post(UPDATE_FOCOLAIO_URL + response2.data.id + "/" + response.data.id + "/" + tipoPaziente, {}, getConfig())
							.then(() => {
								if (response.data.errors) {
									dispatch({
										type: GENERATE_QUARANTENA_SUCCESS,
										payload: response2.data.id,
										data: response.data
									})
								} else {
									if (quarantena.protocollo) {
										//GENERATE PROTOCOLLO
										axios
											.post(GENERATE_PROTOCOLLO_URL, {
												quarantena: {
													id: response.data.id
												},
												anagrafica: quarantena.soggetto
											}, getConfig())
											.then(() => {
												dispatch({
													type: GENERATE_QUARANTENA_SUCCESS,
													payload: response2.data.id,
													data: response.data
												})
											})
											.catch((error) => {
												console.log("#1")
												console.log(error)
												dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)})
											})
										//FINE GENERATE
									} else {
										dispatch({
											type: GENERATE_QUARANTENA_SUCCESS,
											payload: response2.data.id,
											data: response.data
										})
									}
								}
							})
							.catch((error) => {
								console.log("#2")
								console.log(error)
								dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)})
							})
					})
			} else {
				axios
					.post(UPDATE_FOCOLAIO_URL + idFocolaio + "/" + response.data.id + "/" + tipoPaziente, {}, getConfig())
					.then(() => {
						/*--*/
						if (quarantena.protocollo) {
							//GENERATE PROTOCOLLO
							axios
								.post(GENERATE_PROTOCOLLO_URL, {
									quarantena: {
										id: response.data.id
									},
									anagrafica: quarantena.soggetto
								}, getConfig())
								.then(() => {
									dispatch({type: GENERATE_QUARANTENA_SUCCESS, payload: idFocolaio, data: response.data})
								})
								.catch((error) => {
									console.log("#5")
									console.log(error)
									dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)})
								})
							//FINE GENERATE
						} else {
							dispatch({type: GENERATE_QUARANTENA_SUCCESS, payload: idFocolaio, data: response.data})
						}
						/*--*/
						//dispatch({type: GENERATE_QUARANTENA_SUCCESS, payload: idFocolaio, data: response.data})
					})
					.catch((error) => {
						console.log("#3")
						console.log(error)
						dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)})
					})
			}
		})
		.catch((error) => {
			console.log("#4")
			console.log(error)
			dispatch({type: GENERATE_QUARANTENA_FAIL, error: getErrorMessage(error)})
		})
}

export function resetAddQuarantena(dispatch) {
	dispatch({type: GENERATE_QUARANTENA_START});
}

export function getQuarantenaById(idQuarantena, dispatch, token) {
	dispatch({type: GET_QUARANTENA_START});
	axios
		.get(GET_QUARANTENA_URL + idQuarantena + "/" + (token ? token : "NULL"), token ? {} : getConfig())
		.then((response) => dispatch({type: GET_QUARANTENA_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_QUARANTENA_FAIL, error: getErrorMessage(error)}))
}

export function updateQuarantena(quarantena, dispatch) {
	dispatch({type: UPDATE_QUARANTENA_START});
	axios
		.post(UPDATE_QUARANTENA_URL + quarantena.id, quarantena, getConfig())
		.then((response) => dispatch({type: UPDATE_QUARANTENA_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: UPDATE_QUARANTENA_FAIL, error: getErrorMessage(error)}))
}

export function addQuarantenaHistory(data, idQuarantena, dispatch) {
	dispatch({type: ADD_QUARANTENA_HISTORY_START})
	axios
		.post(ADD_QUARANTENA_HISTORY_URL + idQuarantena, data, getConfig())
		.then(() => dispatch({type: ADD_QUARANTENA_HISTORY_SUCCESS}))
		.catch((error) => dispatch({type: ADD_QUARANTENA_HISTORY_FAIL, error: getErrorMessage(error)}))
}

export function getQuarantenaHistory(idQuarantena, dispatch) {
	dispatch({type: GET_QUARANTENA_HISTORY_START});
	axios
		.get(GET_QUARANTENA_HISTORY_URL + idQuarantena, getConfig())
		.then((response) => dispatch({type: GET_QUARANTENA_HISTORY_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_QUARANTENA_HISTORY_FAIL, error: getErrorMessage(error)}))
}

export async function getQuarantenaHistoryArray(idQuarantena, callBackFunction) {
	await axios
		.get(GET_QUARANTENA_HISTORY_URL + idQuarantena, getConfig())
		.then((response) => callBackFunction(response.data))
		.catch((error) => alert(getErrorMessage(error)))
}

export function generateMonitoraggio(monitoraggio, dispatch, token) {
	console.log(monitoraggio);
	dispatch({type: GENERATE_MONITORAGGIO_START});
	axios
		.post(GENERATE_MONITORAGGIO_URL + (token ? token : "NULL"), monitoraggio, token ? {} : getConfig())
		.then(() => dispatch({type: GENERATE_MONITORAGGIO_SUCCESS}))
		.catch((error) => dispatch({type: GENERATE_MONITORAGGIO_FAIL, error: getErrorMessage(error)}))
}

export function askForMonitoraggio(idQuarantena, dispatch) {
	dispatch({type: ASK_FOR_MONITORAGGIO_START});
	axios
		.post(ASK_FOR_MONITORAGGIO_URL + idQuarantena, {}, getConfig())
		.then(() => dispatch({type: ASK_FOR_MONITORAGGIO_SUCCESS}))
		.catch((error) => dispatch({type: ASK_FOR_MONITORAGGIO_FAIL, error: getErrorMessage(error)}))
}

export function getAllMonitoraggiByQuarantena(idQuarantena, dispatch) {
	dispatch({type: GET_ALL_MONITORAGGI_START});
	axios
		.get(GET_ALL_MONITORAGGI_QUARANTENA_URL + idQuarantena, getConfig())
		.then((response) => dispatch({type: GET_ALL_MONITORAGGI_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_ALL_MONITORAGGI_FAIL, error: getErrorMessage(error)}))
}

export function getAllMonitoraggiBySoggetto(idSoggetto, dispatch) {
	dispatch({type: GET_ALL_MONITORAGGI_START});
	axios
		.get(GET_ALL_MONITORAGGI_SOGGETTO_URL + idSoggetto, getConfig())
		.then((response) => dispatch({type: GET_ALL_MONITORAGGI_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_ALL_MONITORAGGI_FAIL, error: getErrorMessage(error)}))
}

export function getFocolaioById(idFocolaio, dispatch) {
	dispatch({type: GET_FOCOLAIO_START});
	axios
		.post(GET_ALL_FOCOLAI_URL + "0/dataUltimaModifica/ASC", {id: idFocolaio}, getConfig())
		.then((response) => dispatch({type: GET_FOCOLAIO_SUCCESS, payload: response.data?.[0]}))
		.catch((error) => dispatch({type: GET_FOCOLAIO_FAIL, error: getErrorMessage(error)}))
}

export function updateFocolaio(focolaio, idFocolaio, dispatch) {
	dispatch({type: UPDATE_FOCOLAIO_START});
	axios
		.post(UPDATE_FOCOLAIO_URL + idFocolaio, focolaio, getConfig())
		.then(() => dispatch({type: UPDATE_FOCOLAIO_SUCCESS}))
		.catch((error) => dispatch({type: UPDATE_FOCOLAIO_FAIL, error: getErrorMessage(error)}))
}

export function getProtocolloById(idProtocollo, dispatch) {
	dispatch({type: GET_PROTOCOLLO_START});
	axios
		.post(GET_ALL_PROTOCOLLI_URL + "/0/dataUltimaModifica/ASC", {id: idProtocollo}, getConfig())
		.then((response) => dispatch({type: GET_PROTOCOLLO_SUCCESS, payload: response.data?.[0]}))
		.catch((error) => dispatch({type: GET_PROTOCOLLO_FAIL, error: getErrorMessage(error)}))
}

export function scaricaProtocolli() {
	window.open(GENERATE_PDF_URL, "_blank");
	/*axios
	 .post(GENERATE_PDF_URL, {}, getConfig())
	 .then((response) => console.log(response))
	 .catch((error) => console.log(error))*/
}

export function scaricaProtocollo(idProtocollo) {
	window.open(DOWNLOAD_PROTOCOLLO_URL + idProtocollo);
}

//Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì
export function protocollaProtocollo(protocollo, dispatch) {//Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì
	dispatch({type: PROTOCOLLA_PROTOCOLLO_START});//Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì
	axios//Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì
		.post(PROTOCOLLA_PROTOCOLLO_URL, getProtocolloData(protocollo), getConfig())//Macrì - //Macrì - //Macrì - //Macrì -
		// //Macrì - //Macrì
		.then(() => dispatch({type: PROTOCOLLA_PROTOCOLLO_SUCCESS}))//Macrì - //Macrì - //Macrì - //Macrì - //Macrì -
		// //Macrì
		.catch((error) => dispatch({type: PROTOCOLLA_PROTOCOLLO_FAIL, error: getErrorMessage(error)}))//Macrì - //Macrì -
                                                                                                  // //Macrì
}//Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì - //Macrì


export function updateProtocollo(protocollo, dispatch) {
	dispatch({type: UPDATE_PROTOCOLLO_START});
	axios
		.post(UPDATE_PROTOCOLLO_URL, protocollo, getConfig())
		.then(() => dispatch({type: UPDATE_PROTOCOLLO_SUCCESS}))
		.catch((error) => dispatch({type: UPDATE_PROTOCOLLO_FAIL, error: getErrorMessage(error)}))
}

export function getAllQuaranteneByMonth(month, dispatch) {
	dispatch({type: GET_QUARANTENE_BY_MONTH_START});
	axios
		.get(GET_QUARANTENE_BY_MONTH_URL + moment(startOfMonth(month)).format("DD-MM-YYYY") + "/" + moment(endOfMonth(month)).format("DD-MM-YYYY"), getConfig())
		.then((response) => {
			let map = {
				in: {},
				qn: {},
				is: {},
				qs: {},
			}
			try {
				Object.entries(response.data["Isolamenti (nuovi)"])?.forEach(([key, val]) => {
					map.in[new Date(key)] = val
				})
				
				Object.entries(response.data["Quarantene (nuovi)"])?.forEach(([key, val]) => {
					map.qn[new Date(key)] = val
				})
				
				Object.entries(response.data["Isolamenti (in scadenza)"])?.forEach(([key, val]) => {
					map.is[new Date(key)] = val
				})
				
				Object.entries(response.data["Quarantene (in scadenza)"])?.forEach(([key, val]) => {
					map.qs[new Date(key)] = val
				})
			} catch (e) {
				console.log(e)
			}
			dispatch({type: GET_QUARANTENE_BY_MONTH_SUCCESS, payload: map})
		})
		.catch((error) => dispatch({type: GET_QUARANTENE_BY_MONTH_FAIL, error: getErrorMessage(error)}))
}

export function getQuaranteneByEndDay(data, dispatch, page) {
	dispatch({type: GET_QUARANTENE_BY_DAY_START});
	axios
		.post(GET_ALL_QUARANTENE_URL + page + "/ultimaModifica/ASC", data, getConfig())
		.then((response) => dispatch({type: GET_QUARANTENE_BY_DAY_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_QUARANTENE_BY_DAY_FAIL, error: getErrorMessage(error)}))
}

export function getAllInfoQuarantene(dispatch, data) {
	dispatch({type: GET_ALL_INFO_QUARANTENE_START});
	axios
		.post(GET_ALL_INFO_QUARANTENE_URL, data, getConfig())
		.then((response) => dispatch({type: GET_ALL_INFO_QUARANTENE_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_ALL_INFO_QUARANTENE_FAIL, error: getErrorMessage(error)}))
}

export function getAllInfoProtocolli(dispatch) {
	dispatch({type: GET_ALL_INFO_PROTOCOLLI_START});
	axios
		.post(GET_ALL_INFO_PROTOCOLLI_URL, {}, getConfig())
		.then((response) => dispatch({type: GET_ALL_INFO_PROTOCOLLI_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_ALL_INFO_PROTOCOLLI_FAIL, error: getErrorMessage(error)}))
}

export function resetQuaranteneDay(dispatch) {
	dispatch({type: RESET_GET_QUARANTENE_DAY});
}

export function concludiDecorso(dispatch, data) {
	dispatch({type: ADD_STORICO_PRENOTAZIONE_START});
	axios
		.post(ADD_STORICO_PRENOTAZIONE_URL, data, getConfig())
		.then(() => {
			axios
				.post(GET_ALL_QUARANTENE_URL + "0/ultimaModifica/ASC", {
					soggetto: data.soggetto,
				}, getConfig())
				.then((response) => {
					let quarantena = response.data?.[0];
					axios
						.post(UPDATE_QUARANTENA_URL + quarantena?.id, {
							...quarantena,
							stato: "CONCLUSA",
							active: false,
							note: "Chiusa"
						}, getConfig())
						.then(() => dispatch({type: ADD_STORICO_PRENOTAZIONE_SUCCESS}))
				})
		})
		.catch((error) => dispatch({type: ADD_STORICO_PRENOTAZIONE_FAIL, error: getErrorMessage(error)}))
}

export function modifyAliasFocolaio(idFocolaio, alias, dispatch) {
	dispatch({type: MODIFY_ALIAS_FOCOLAIO_START});
	axios
		.post(MODIFY_ALIAS_FOCOLAIO_URL + idFocolaio + "/" + alias, {}, getConfig())
		.then(() => dispatch({type: MODIFY_ALIAS_FOCOLAIO_SUCCESS}))
		.catch((error) => dispatch({type: MODIFY_ALIAS_FOCOLAIO_FAIL, error: getErrorMessage(error)}))
}
